import React, { Component } from 'react';
//import Filter from './FilterService'
// Material components
import Badge from '@material-ui/core/Badge';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import compose from 'recompose/compose';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Grid } from '@material-ui/core';
import 'moment/locale/es'
import Popover from '@material-ui/core/Popover';
import styles from './styles';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import at_error_codes from '../../../../../../data/at_error_codes'
import {getObjectiveLastStatus} from '../../../../../../services/getLastStatusObjective'
import { VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import Hidden from '@material-ui/core/Hidden';
import Tooltip from '@material-ui/core/Tooltip'

class ObjectiveVertical extends Component {

    constructor(props) {
        super(props)
    
        //console.log('props',props)
        this.state = {
            element:this.props.data,
            isLoading:true,
            colorElement:null,
            group:this.props.orderGroup,
            open:false,
            anchorEl: null,
            nodesStatus:[],
            openStep:false,
            anchorElStep: null,
            stepsStatus:[],
            okStatus:[0,9,14,17,30,200,204,301,304,307,602,1000]
        }
    }

    componentDidMount() {
        this.processData();
    }

    static getDerivedStateFromProps( prevState, state) {
        //console.log('derived Objective',prevState.data, state.element)
        if(prevState.data.id!== state.element.id){
            //console.log('prev', prevState)
            return{
                element:prevState.data,
            }
        }
        
        return null
    }

    /*componentDidUpdate(prevProps, prevState) {
        console.log(prevProps.data, this.state.element, prevState.element)
        //this.processData()
    }*/

    processData = () => {
        const {element, group}=this.state
        
        //console.log('process', element)
        var iconService=<DesktopWindowsIcon style={{width:"100px"}}/>
        if(element.servicio===700){
            iconService=<PhoneIphoneIcon style={{width:"100px" }}/>
        }
       
        getObjectiveLastStatus(element.id)
        .then(value=>{
            //console.log(value)
            //console.log('obj', value.objetivo_id)
            
            var color = '#41B900'
            if(value.status_objetivo==="downtime"){
                color='#C2272D'
            }
            if(value.status_objetivo==="parcial"){
                color='#FFC600'
            }
            if(value.status_objetivo==="no_monitoreo"){
                color='#A9A9A9'
            }
            element["color"]=color
            element["group"]=group
            element["icon"]=iconService
            element["monitores"]=value["monitores"]
            //sessionStorage.setItem(element.id,JSON.stringify(element))
            //sessionStorage.setItem("colorGlobal","true")
            
            this.setState({ 
                isLoading:false,
                colorElement:color,
            })
            //console.log(value)
            this.props.InfoObjective(element)
        })
    }
    elementDot=(e,object)=>{
        const {okStatus}=this.state
        //console.log('click',e.monitores)
        e.monitores.map(ele=>{
            if(okStatus.includes(parseInt(ele.pasos_caidos))===true){
                ele["estado_nodo"]="rgb(65, 185, 0)"
            }else{
                ele["estado_nodo"]="rgb(194, 39, 45)"
            }
        })
        //console.log(e)
        this.setState({ 
            open:true,
            anchorEl: object.currentTarget,
            nodesStatus:e.monitores
        })
    }

    onCloseModal=()=>{
        this.setState({ 
            open:false,
            anchorEl: null
        })
    }

    eleNode=(e,object)=>{
        const {okStatus}=this.state
        //console.log('click',e)
        e.pasos.map(ele=>{
            console.log(ele.ultimo_estado)
            var filterStep=(at_error_codes.filter(i=>i.id===parseInt(ele.ultimo_estado))[0])
            
            if(okStatus.includes(parseInt(ele.ultimo_estado))===true){
                ele["color_paso"]="rgb(65, 185, 0)"
                ele["tooltip"]=true 
            }else{
                ele["nombre_estado"]=filterStep.nombre
                ele["descripcion_estado"]=filterStep.descripcion
                ele["color_paso"]="rgb(194, 39, 45)"
                ele["tooltip"]=false 
            }
        })
        this.setState({ 
            openStep:true,
            anchorElStep: object.currentTarget,
            stepsStatus:e.pasos
        })
    }

    onCloseModalStep=()=>{
        this.setState({ 
            openStep:false,
            anchorElStep: null
        })
    }
    
    
    

    render() {
        const {isLoading, element, colorElement, icon, open, anchorEl, nodesStatus, openStep, anchorElStep, stepsStatus}=this.state
        //console.log(stepsStatus)
        //console.log(element)
        const {classes}=this.props
        if (isLoading===true) {
            return(
                <Grid 
                container
                direction="row"
                justify="center"
                alignItems="center"
                className={classes.contentCircular}>
                    <Grid item lg={12} xl={12}>
                        <Typography
                        className={classes.circular}
                            variant="caption"
                            >
                            <CircularProgress
                            className={classes.circular}
                            variant="indeterminate"
                            size={8}
                            thickness={1}
                            
                            />
                            Cargando Grupos...
                        </Typography>
                    </Grid>
                </Grid>
            )
        }else{
            //console.log('nodes', nodesStatus)
            //console.log(window.innerWidth)
            var positionDot="24%"
            if(window.innerWidth<1920 && window.innerWidth>=1440){
                positionDot="25%"
            }
            if(window.innerWidth<1440 && window.innerWidth>=1280){
                positionDot="27%"
            }
            if(window.innerWidth<500 && window.innerWidth>=400){
                positionDot="7%"
            }
            if(window.innerWidth<400 && window.innerWidth>0){
                positionDot="6%"
            }
            return(
                <VerticalTimelineElement
                    
                    style={{margin:"0 0 0 0"}}
                    position="right"
                    key={element.nombre}
                    
                    //style={{'& span':{color:"red"}}}
                    //className="vertical-timeline-element--work"
                    //contentStyle={{background:colorElement}}
                    //ARROW
                    contentArrowStyle={{ borderRight: '7px solid ', left:"-36px"}}
                    //DIV DE CONTENIDO DE TEXTO
                    contentStyle={{width:"72%", boxShadow: "0 0 0"}}
                    //DOT
                    iconStyle={{ background: colorElement , width:"15px", top:"24px", height:"14px", left:positionDot}}
                    date={element.icon}
                    >
                    <Hidden only={["md", 'xl', 'lg']}>
                        <Typography    style={{margin:"0em -2px 0px -11px", color:colorElement, fontWeight: 'bold', fontSize:"12px"}}>{element.nombre}</Typography>
                    </Hidden>
                    
                    <Hidden smDown>
                    <Typography onClick={this.elementDot.bind(this, element)} style={{margin:"0em -2px 0px -11px", color:"#615F5F", fontWeight: 'bold', fontSize:"12px"}}>{element.nombre}</Typography>
                    </Hidden>
                    <Popover open={open}
                        anchorEl={anchorEl}
                        onClose={this.onCloseModal} 
                        anchorOrigin={{vertical: 'center', horizontal: 'right'}}
                        transformOrigin={{vertical: 'center', horizontal: 'center' }}>
                        {nodesStatus.map(ele=>( 
                            <Grid key={ele.monitor} container direction="row" justify="center" alignItems="center" spacing={3}>
                                    <Grid item xs={2} lg={2} md={2} xl={2}>
                                        <div style={{height: "12px", width: "12px",backgroundColor: ele.estado_nodo, borderRadius: "50%"}} ></div>
                                    </Grid>
                                    <Button style={{width:"150px", height:"50px", cursor: "default"}} /* onClick={this.eleNode.bind(this, ele)} */ >
                                        <Grid item xs={10} lg={10} md={10} xl={10}>{ele.nodo}</Grid>
                                    </Button>
                            </Grid>
                        ))}
                    </Popover>
                    <Popover open={openStep}
                        anchorEl={anchorElStep}
                        onClose={this.onCloseModalStep} 
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                          }}>
                        {stepsStatus.map(ele=>( 
                            <Grid key={ele.id_paso+ele.nombre_paso} container direction="row" justify="center" alignItems="center" spacing={3}>
                                <Grid item xs={2} lg={2} md={2} xl={2}>
                                    <div style={{height: "12px", width: "12px",backgroundColor: ele.color_paso, borderRadius: "50%"}} ></div>
                                </Grid>
                                <Grid item xs={4} lg={4} md={4} xl={4}>
                                    <Typography style={{fontSize:"1rem"}}  variant="h6">{ele.nombre_paso}</Typography>
                                </Grid>
                                <Grid  item xs={2} lg={2} md={2} xl={2}>
                                    <Typography style={{fontSize:"0.7rem"}} variant="h6">[{ele.tiempo}]</Typography>
                                </Grid>
                                <Grid  item xs={4} lg={4} md={4} xl={4}>
                                    <Tooltip title={ele.descripcion_estado} placement="top-start">
                                        <Typography style={{fontSize:"0.8rem"}} variant="h6">{ele.nombre_estado}</Typography>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        ))}
                    </Popover>


                </VerticalTimelineElement>
            )
        }
   
    }
}
export default
    compose(withStyles(styles))(ObjectiveVertical);